export default __webpack_public_path__ + "static/media/document-upload.e95019c0.svg";